import { jsx as l, jsxs as t } from "react/jsx-runtime";
import "react";
var s = (a) => /* @__PURE__ */ t("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ...a,
  children: [
    /* @__PURE__ */ l("path", {
      fill: "#338AF3",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "M31.304 20.217H8.696c0 1.561 1.36 2.827 2.92 2.827h-.094a2.826 2.826 0 0 0 2.826 2.826 2.826 2.826 0 0 0 2.826 2.826h5.652a2.826 2.826 0 0 0 2.826-2.826 2.826 2.826 0 0 0 2.826-2.826h-.094c1.56 0 2.92-1.266 2.92-2.827Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#338AF3",
      d: "M27.826 16.522a7.826 7.826 0 0 1-15.652 0"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "m25.978 16.522-2.443 1.149 1.3 2.365-2.652-.507-.336 2.68L20 20.237l-1.848 1.97-.336-2.68-2.652.508 1.3-2.365-2.442-1.15 2.443-1.148-1.3-2.366 2.651.508.337-2.68L20 12.805l1.848-1.97.335 2.68 2.653-.508-1.3 2.366 2.442 1.149Z"
    })
  ]
});
export {
  s as default
};
